import {
  stringifyRgba
} from "@pathwright/ui/src/components/utils/colors"
import { ConnectStores } from "lib/core/store"
import ResourceThemeForm from "./ResourceThemeForm"

const mapStateToProps = function (state, ownProps) {
  const { resource } = state.resourceAdminStore.state
  const { saveResource } = state.resourceAdminStore.action

  const fieldValues = {
    background: {
      url: resource?.background_image,
      image: resource?.background_image
    },
    overlay: resource?.background_overlay,
    blur: resource?.background_type === 5 ? true : false
  }

  const onSubmit = function (fieldsData, resetForm) {
    const resourceId = resource?.id
    const resourceData = {
      background_image: fieldsData.background.value.url,
      background_type: fieldsData.blur.value ? 5 : 1,
      background_overlay: stringifyRgba(fieldsData.overlay.value)
    }
    return saveResource(resourceData).promise.then(() =>
      window.apolloClientStoreBridge.refetchResource({
        id: resourceId
      })
    )
  }

  return _.assign(
    {},
    {
      fieldValues,
      resourceID: resource?.id,
      onSubmit
    },
    ownProps
  )
}

const stores = [{ store: "resourceAdmin", watch: ["resource"] }]

const ResourceThemeFormContainer = ConnectStores(
  ResourceThemeForm,
  stores,
  {},
  mapStateToProps
)

ResourceThemeFormContainer.displayName = "ResourceThemeFormContainer"

export default ResourceThemeFormContainer
